import React, { useEffect } from "react";
import { getFullUrl, getEssentialUrl } from "lib/urlQueryParser";
import { withStore } from "store/storeHandler";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

GatewayCheckpoint.propTypes = {
  children: PropTypes.element,
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

function GatewayCheckpoint(props) {
  const { children, type, url } = props;
  const { hasLoggedIn } = props;

  const history = useHistory();

  useEffect(() => {
    const accountPageUrl = getFullUrl({
      url: getEssentialUrl({ type: "account" })(),
      queryObj: { next: url }
    });
    if (!hasLoggedIn) {
      if (type === "replace") {
        history.replace(accountPageUrl);
      } else if (type === "push") {
        history.push(accountPageUrl);
      }
    }
  }, []);

  return <div>{hasLoggedIn && children}</div>;
}

export default withStore({ stateMap: { myAccount: ["hasLoggedIn"] } })(
  GatewayCheckpoint
);
